export default __webpack_public_path__ + "static/media/step-3.ebb1bec5.mp4";